import { Stack, TextField, Typography } from "@mui/material";
import React from "react";

export default function FormField({label,inputProps,labelVarient="label"}){
    return(
        <Stack direction={"column"} spacing={label ? 1 : 0}>
            {label ? <Typography variant={labelVarient}>{label}</Typography> : null}
            <TextField {...inputProps} />
        </Stack>
    )
}